<template>
  <div>
    <b-card title="IVF Expenses Form">
      <h3 class="text-center my-4">Expenses</h3>
      <b-row v-for="(item, index) in items" :key="index">
        <b-col md="6" cols="12">
          <b-form-group label="Description" label-for="Description">
            <b-form-input
              id="Description"
              v-model="item.description"
              placeholder="Enter Description"
            />
          </b-form-group>
        </b-col>
        <b-col md="2" cols="12">
          <b-form-group label="Price IQD" label-for="IQD">
            <b-form-input
              type="number"
              id="IQD"
              v-model="item.priceIQD"
              placeholder="Enter Price IQD"
            />
          </b-form-group>
        </b-col>
        <b-col md="2" cols="12">
          <b-form-group label="Price USD" label-for="USD">
            <b-form-input
              type="number"
              id="USD"
              v-model="item.priceUSD"
              placeholder="Enter Price USD"
            />
          </b-form-group>
        </b-col>
        <b-col class="d-flex align-items-center w-full" md="2" cols="12">
          <b-button
            class="mx-1 w-full"
            variant="primary"
            size="sm"
            @click="addItem"
            >+</b-button
          >
          <b-button
            :disabled="index === 0"
            size="sm"
            variant="danger"
            @click="removeItem(index)"
            >X</b-button
          >
        </b-col>
      </b-row>

      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button style="margin: auto" variant="primary">
          Print IVF Expenses
          <b-icon-person-check class="ml-1"></b-icon-person-check>
        </b-button>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    VueHtml2pdf,
  },

  data() {
    return {
      patientName: '',
      operationExpenses: '',
      fileNumber: '',
      responsibleSurgon: '',
      responsibleNurse: '',
      items: [
        {
          description: '',
          priceIQD: null,
          priceUSD: '',
        },
      ],
    };
  },
  methods: {
    addItem() {
      this.items.push({
        name: '',
        count: null,
        brand: '',
      });
    },
    removeItem(index) {
      if (index === 0) return;
      this.items.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
